export default class SupporterScroll {
  constructor() {
    this.intervalId = null;
    this.init();
  }

  init() {
    const messageContainer = document.querySelector(".supporter-messages-container");
    const messages = document.querySelector(".fb-messages");
    const firstMessage = document.querySelector(".fb-message");

    // Check if all necessary elements exist
    if (!messageContainer || !messages || !firstMessage) {
      return;
    }

    const totalMessageHeight = messages.scrollHeight;
    const messageContainerHeight = messageContainer.clientHeight;

    if (totalMessageHeight > messageContainerHeight) {
      this.startAnimation(firstMessage);

      const pauseButton = document.querySelector(".pause-button");
      const playButton = document.querySelector(".play-button");

      if (pauseButton && playButton) {
        pauseButton.addEventListener("click", () => {
          this.stopAnimation();
          pauseButton.style.display = 'none';
          playButton.style.display = 'inline-block';
        });

        playButton.addEventListener("click", () => {
          this.startAnimation(firstMessage);
          playButton.style.display = 'none';
          pauseButton.style.display = 'inline-block';
        });
      }
    }
  }

  startAnimation(firstMessage) {
    const messageContainer = document.querySelector(".fb-messages");

    if (!messageContainer || !firstMessage) return;

    const animate = () => {
      const firstMessageHeight = firstMessage.offsetHeight;

      if (firstMessageHeight > 0) {
        messageContainer.style.transition = "top 0.5s";
        messageContainer.style.top = `-${firstMessageHeight}px`;

        setTimeout(() => this.animateCallback(), 500);
      }
    };

    this.intervalId = setInterval(animate, 5000);
  }

  stopAnimation() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  animateCallback() {
    const messageContainer = document.querySelector(".fb-messages");
    const firstMessage = document.querySelector(".fb-message");

    if (messageContainer && firstMessage) {
      messageContainer.appendChild(firstMessage);
      messageContainer.style.transition = "none";
      messageContainer.style.top = "0";
    }
  }
}
